/* ============================================
   SNEAKER EXPLORER — JavaScript
   GoodSneakers.store
   ============================================ */

(function () {
  'use strict';

  let explorerData = null;
  let activeHotspotId = null;

  /* ── Init ─────────────────────────────────── */
  function init() {
    const dataEl = document.getElementById('se-data');
    if (!dataEl) return;

    try {
      explorerData = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.warn('[SneakerExplorer] JSON inválido no metafield.');
      return;
    }

    buildModal();
    bindTrigger();
  }

  /* ── Build modal HTML ─────────────────────── */
  function buildModal() {
    if (document.getElementById('se-overlay')) return;

    const overlay = document.createElement('div');
    overlay.id = 'se-overlay';
    overlay.className = 'se-overlay';
    overlay.innerHTML = `
      <div class="se-modal" role="dialog" aria-modal="true" aria-label="Sneaker Explorer">

        <!-- Header -->
        <div class="se-header">
          <div class="se-header-left">
            <div class="se-header-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                <line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/>
              </svg>
            </div>
            <div>
              <div class="se-header-title">EXPLORAR DETALHES</div>
              <div class="se-header-subtitle">Descubra cada detalhe deste ícone.</div>
            </div>
          </div>
          <button class="se-close" id="se-close" aria-label="Fechar">&#x2715;</button>
        </div>

        <!-- Body -->
        <div class="se-body">

          <!-- Image + hotspots -->
          <div class="se-image-area">
            <div class="se-image-wrap" id="se-image-wrap">

              <!-- Frente: imagem hero (hotspots injetados por JS aqui) -->
              <img id="se-hero-img" src="" alt="" />

              <!-- Verso do card flip: close-up do hotspot -->
              <div class="se-card-back" id="se-card-back">
                <img class="se-flip-thumb-img" id="se-flip-thumb-img" src="" alt="" />
                <div class="se-flip-fallback" id="se-flip-fallback">
                  <div class="se-flip-fallback-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                    </svg>
                  </div>
                  <div class="se-flip-fallback-label" id="se-flip-fallback-label"></div>
                </div>
              </div>

            </div>
          </div>

          <!-- Panel -->
          <div class="se-panel" id="se-panel">

            <!-- Overview -->
            <div class="se-overview" id="se-overview">
              <div class="se-overview-model" id="se-model-label"></div>
              <div class="se-overview-name" id="se-product-name"></div>
              <div class="se-overview-desc" id="se-product-desc"></div>
              <div class="se-overview-hint">
                <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="12"/>
                  <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                Clique nos pontos para explorar cada detalhe
              </div>
            </div>

            <!-- Detail -->
            <div class="se-detail" id="se-detail">
              <div class="se-detail-top">
                <button class="se-back-btn" id="se-back">
                  <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6"/>
                  </svg>
                  VOLTAR
                </button>
                <div class="se-detail-label" id="se-detail-label"></div>
                <div class="se-detail-accent"></div>
              </div>

              <img class="se-thumb" id="se-detail-thumb" src="" alt="" style="display:none">

              <div class="se-detail-items">
                <div class="se-detail-item" id="se-item-material" style="display:none">
                  <div class="se-detail-item-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                    </svg>
                  </div>
                  <div>
                    <div class="se-detail-item-label">Material</div>
                    <div class="se-detail-item-text" id="se-material-text"></div>
                  </div>
                </div>

                <div class="se-detail-item" id="se-item-design" style="display:none">
                  <div class="se-detail-item-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/>
                    </svg>
                  </div>
                  <div>
                    <div class="se-detail-item-label">Design</div>
                    <div class="se-detail-item-text" id="se-design-text"></div>
                  </div>
                </div>

                <div class="se-detail-item" id="se-item-curiosidade" style="display:none">
                  <div class="se-detail-item-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                    </svg>
                  </div>
                  <div>
                    <div class="se-detail-item-label">Curiosidade</div>
                    <div class="se-detail-item-text" id="se-curiosidade-text"></div>
                  </div>
                </div>
              </div>

              <div class="se-counter" id="se-counter"></div>
            </div>

          </div>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    document.getElementById('se-close').addEventListener('click', closeModal);
    document.getElementById('se-back').addEventListener('click', showOverview);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  /* ── Bind trigger button ──────────────────── */
  function bindTrigger() {
    const btn = document.getElementById('se-trigger');
    if (!btn) return;
    btn.addEventListener('click', openModal);
  }

  /* ── Open modal ───────────────────────────── */
  function openModal() {
    if (!explorerData) return;

    const heroImg = document.getElementById('se-hero-img');
    heroImg.alt = explorerData.product || '';
    document.getElementById('se-model-label').textContent = explorerData.template ? explorerData.template.replace(/-/g, ' ').toUpperCase() : '';
    document.getElementById('se-product-name').textContent = explorerData.product || '';
    document.getElementById('se-product-desc').textContent = explorerData.description || '';

    heroImg.src = explorerData.hero_image || '';

    // Garante que começa na frente ao reabrir
    document.getElementById('se-image-wrap').classList.remove('is-flipped');

    showOverview();
    document.getElementById('se-overlay').classList.add('is-open');
    document.body.style.overflow = 'hidden';

    heroImg.onload = renderHotspots;
    if (heroImg.complete && heroImg.naturalWidth > 0) {
      renderHotspots();
    }
    setTimeout(renderHotspots, 300);
  }

  /* ── Close modal ──────────────────────────── */
  function closeModal() {
    document.getElementById('se-overlay').classList.remove('is-open');
    document.body.style.overflow = '';
    activeHotspotId = null;
  }

  /* ── Render hotspots ──────────────────────── */
  function renderHotspots() {
    const wrap = document.getElementById('se-image-wrap');
    // Remove apenas os hotspots, preserva o verso (.se-card-back)
    wrap.querySelectorAll('.se-hotspot').forEach(el => el.remove());
    wrap.classList.remove('has-active');

    if (!explorerData.hotspots) return;

    explorerData.hotspots.forEach(function (h) {
      const el = document.createElement('div');
      el.className = 'se-hotspot';
      el.dataset.id = h.id;
      el.style.cssText = [
        'position: absolute',
        'left: ' + h.x + '%',
        'top: ' + h.y + '%',
        'transform: translate(-50%, -50%)',
        'width: 36px',
        'height: 36px',
        'border-radius: 50%',
        'background: rgba(218,98,113,0.25)',
        'border: 2px solid #DA6271',
        'display: flex',
        'align-items: center',
        'justify-content: center',
        'color: #fff',
        'font-size: 20px',
        'font-weight: 300',
        'cursor: pointer',
        'z-index: 100',
        'box-shadow: 0 0 0 0 rgba(255,255,255,0.4)',
        'animation: se-pulse 2s ease-in-out infinite',
        'transition: background 0.2s, border-color 0.2s',
        /* Garante que o hotspot some no verso do flip */
        'backface-visibility: hidden',
        '-webkit-backface-visibility: hidden'
      ].join(';');
      el.textContent = '+';
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        showDetail(h);
      });
      wrap.appendChild(el);
    });
  }

  /* ── Show overview ────────────────────────── */
  function showOverview() {
    activeHotspotId = null;

    // Desfaz o flip — imagem hero volta à frente
    document.getElementById('se-image-wrap').classList.remove('is-flipped');

    document.querySelectorAll('.se-hotspot').forEach(el => el.classList.remove('is-active'));
    document.getElementById('se-image-wrap').classList.remove('has-active');

    document.getElementById('se-overview').style.display = '';
    document.getElementById('se-detail').classList.remove('is-visible');
  }

  /* ── Show detail ──────────────────────────── */
  function showDetail(hotspot) {
    activeHotspotId = hotspot.id;

    // Atualiza hotspots visuais
    document.querySelectorAll('.se-hotspot').forEach(function (el) {
      el.classList.toggle('is-active', el.dataset.id === hotspot.id);
    });
    document.getElementById('se-image-wrap').classList.add('has-active');

    // Prepara o verso com thumbnail ou fallback
    var flipImg      = document.getElementById('se-flip-thumb-img');
    var flipFallback = document.getElementById('se-flip-fallback');
    var flipLabel    = document.getElementById('se-flip-fallback-label');

    flipLabel.textContent = hotspot.label || '';

    if (hotspot.thumbnail) {
      flipImg.src = hotspot.thumbnail;
      flipImg.alt = hotspot.label || '';
      flipImg.style.display = 'block';
      flipFallback.style.display = 'none';
    } else {
      flipImg.style.display = 'none';
      flipFallback.style.display = 'flex';
    }

    // Dispara o flip 3D no image-wrap
    document.getElementById('se-image-wrap').classList.add('is-flipped');

    // Preenche painel
    document.getElementById('se-detail-label').textContent = hotspot.label || '';

    const thumb = document.getElementById('se-detail-thumb');
    if (hotspot.thumbnail) {
      thumb.src = hotspot.thumbnail;
      thumb.style.display = 'block';
    } else {
      thumb.style.display = 'none';
    }

    setDetailItem('se-item-material',    'se-material-text',    hotspot.material);
    setDetailItem('se-item-design',      'se-design-text',      hotspot.design);
    setDetailItem('se-item-curiosidade', 'se-curiosidade-text', hotspot.curiosidade);

    const idx = explorerData.hotspots.findIndex(h => h.id === hotspot.id);
    document.getElementById('se-counter').textContent =
      (idx + 1) + ' / ' + explorerData.hotspots.length;

    document.getElementById('se-overview').style.display = 'none';
    document.getElementById('se-detail').classList.add('is-visible');
    document.getElementById('se-panel').scrollTop = 0;
  }

  /* ── Helper: mostra/esconde item de detalhe ── */
  function setDetailItem(wrapperId, textId, value) {
    const wrapper = document.getElementById(wrapperId);
    const textEl  = document.getElementById(textId);
    if (value && value.trim()) {
      textEl.textContent = value;
      wrapper.style.display = 'flex';
    } else {
      wrapper.style.display = 'none';
    }
  }

  /* ── Start ────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();